module.exports = __webpack_public_path__ + "img/42.6b3101c0.jpg";